module.exports = __webpack_public_path__ + "img/icon-add blue.2af7f2ae.svg";